import r from "../managers/braze-instance.js";
import rr from "./content-cards-provider-factory.js";
export function subscribeToContentCardsUpdates(o) {
  if (!r.rr()) return;
  var t = rr.o(),
    n = t.St(o);
  if (!t.jt()) {
    var _o = r.nn();
    if (_o) {
      var _r = _o.rn(function () {
        t.fi(void 0, void 0, !0);
      });
      _r && t.yt(_r);
    }
  }
  return n;
}